// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ComboboxController from "./combobox_controller"
application.register("combobox", ComboboxController)

import ConfirmationModalController from "./confirmation_modal_controller"
application.register("confirmation-modal", ConfirmationModalController)

import DateRangeController from "./date_range_controller"
application.register("date-range", DateRangeController)

import DrawerController from "./drawer_controller"
application.register("drawer", DrawerController)

import MenuSearchController from "./menu_search_controller"
application.register("menu-search", MenuSearchController)

import OutletMatrixController from "./outlet_matrix_controller"
application.register("outlet-matrix", OutletMatrixController)

import SearchFormController from "./search_form_controller"
application.register("search-form", SearchFormController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import ItemMatrixController from "./item_matrix_controller"
application.register("item-matrix", ItemMatrixController)

import ReportLoaderController from "./report_loader_controller"
application.register("report-loader", ReportLoaderController)

import ReportGrainController from "./report_grain_controller"
application.register("report-grain", ReportGrainController)

import TableRowController from "./table_row_controller"
application.register("table-row", TableRowController)

import RefreshController from "./refresh_controller"
application.register("refresh", RefreshController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import RecipeLineController from "./recipe_line_controller"
application.register("recipe-line", RecipeLineController)

import OutletSwitcherController from "./outlet_switcher_controller"
application.register("outlet-switcher", OutletSwitcherController)
